/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationAtsAutomationSettingsDataSchema = z.object({
	autoGenerateCampaigns: z.boolean(),
	autoCloseCampaigns: z.boolean(),
})

export type OrganisationAtsAutomationSettingsDataSchema = z.infer<typeof organisationAtsAutomationSettingsDataSchema>
